
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-follow",
      function () {
        return require("private-next-pages/order-follow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-follow"])
      });
    }
  